// choices/paletteChoices.js
import { images } from "../../components/utility/imageImports";

const paletteChoicesRo = [
  {
    label: "Albastru",
    value: "blues",
    imageUrl: images["blues.png"],
  },

  {
    label: "Verde",
    value: "greens",
    imageUrl: images["greens.png"],
  },

  {
    label: "Galben",
    value: "yellows",
    imageUrl: images["yellows.png"],
  },

  {
    label: "Roșu",
    value: "reds",
    imageUrl: images["reds.png"],
  },

  {
    label: "Portocaliu",
    value: "oranges",
    imageUrl: images["oranges.png"],
  },

  {
    label: "Violet",
    value: "violets",
    imageUrl: images["violets.png"],
  },

  {
    label: "Alb",
    value: "whites",
    imageUrl: images["whites.png"],
  },

  {
    label: "Gri",
    value: "grays",
    imageUrl: images["grays.png"],
  },

  {
    label: "Maro",
    value: "browns",
    imageUrl: images["browns.png"],
  },
];

export default paletteChoicesRo;
